export interface WheelSegment {
  id: string;
  d: string;
  fill: string;
  delay: number;
  wheelName: string;
}

// Outer ring segments (business stages)
export const WHEEL_STAGES: WheelSegment[] = [
  {
    id: "culture",
    d: "M 311.10 153.38 A 386 386 0 0 1 688.90 153.38 L 622.35 271.98 A 250 250 0 0 0 377.65 271.98 Z",
    fill: "#1C1349",
    delay: 0,
    wheelName: "Build Your Culture & Lead",
  },
  {
    id: "strategy",
    d: "M 697.07 158.10 A 386 386 0 0 1 885.97 485.28 L 749.98 486.95 A 250 250 0 0 0 627.64 275.04 Z",
    fill: "#1C1349",
    delay: 0.045,
    wheelName: "Strategy & Planning",
  },
  {
    id: "buildteam",
    d: "M 885.97 494.72 A 386 386 0 0 1 697.07 821.90 L 627.64 704.96 A 250 250 0 0 0 749.98 493.05 Z",
    fill: "#1C1349",
    delay: 0.09,
    wheelName: "Build Your Team",
  },
  {
    id: "mgmt",
    d: "M 688.90 826.62 A 386 386 0 0 1 311.10 826.62 L 377.65 708.02 A 250 250 0 0 0 622.35 708.02 Z",
    fill: "#1C1349",
    delay: 0.135,
    wheelName: "Management Development",
  },
  {
    id: "develop",
    d: "M 302.93 821.90 A 386 386 0 0 1 114.03 494.72 L 250.02 493.05 A 250 250 0 0 0 372.36 704.96 Z",
    fill: "#1C1349",
    delay: 0.18,
    wheelName: "Develop Your Team",
  },
  {
    id: "scale",
    d: "M 114.03 485.28 A 386 386 0 0 1 302.93 158.10 L 372.36 275.04 A 250 250 0 0 0 250.02 486.95 Z",
    fill: "#1C1349",
    delay: 0.225,
    wheelName: "Scale Your Business",
  },
];

// Inner ring wedges (process steps)
export const WHEEL_WEDGES: WheelSegment[] = [
  {
    id: "intake",
    d: "M 420.81 261.32 A 242 242 0 0 1 579.19 261.32 L 532.07 397.40 A 98 98 0 0 0 467.93 397.40 Z",
    fill: "#C8102E",
    delay: 0,
    wheelName: "Booking the Call",
  },
  {
    id: "dispatch",
    d: "M 586.33 263.92 A 242 242 0 0 1 707.65 365.72 L 584.09 439.67 A 98 98 0 0 0 534.96 398.45 Z",
    fill: "#C8102E",
    delay: 0.045,
    wheelName: "Schedule & Dispatch",
  },
  {
    id: "run",
    d: "M 711.45 372.31 A 242 242 0 0 1 738.95 528.27 L 596.77 505.50 A 98 98 0 0 0 585.63 442.34 Z",
    fill: "#93A9AD",
    delay: 0.09,
    wheelName: "Run the Call",
  },
  {
    id: "debrief",
    d: "M 737.63 535.76 A 242 242 0 0 1 658.45 672.92 L 564.16 564.07 A 98 98 0 0 0 596.23 508.53 Z",
    fill: "#93A9AD",
    delay: 0.135,
    wheelName: "Debrief & Close Out",
  },
  {
    id: "inventory",
    d: "M 652.62 677.80 A 242 242 0 0 1 503.80 731.97 L 501.54 587.99 A 98 98 0 0 0 561.81 566.05 Z",
    fill: "#93A9AD",
    delay: 0.18,
    wheelName: "Restock & Reconcile",
  },
  {
    id: "finance",
    d: "M 496.20 731.97 A 242 242 0 0 1 347.38 677.80 L 438.19 566.05 A 98 98 0 0 0 498.46 587.99 Z",
    fill: "#F8C44E",
    delay: 0.225,
    wheelName: "Financial Reporting",
  },
  {
    id: "reports",
    d: "M 341.55 672.92 A 242 242 0 0 1 262.37 535.76 L 403.77 508.53 A 98 98 0 0 0 435.84 564.07 Z",
    fill: "#F8C44E",
    delay: 0.27,
    wheelName: "Review KPIs",
  },
  {
    id: "inspect",
    d: "M 261.05 528.27 A 242 242 0 0 1 288.55 372.31 L 414.37 442.34 A 98 98 0 0 0 403.23 505.50 Z",
    fill: "#F8C44E",
    delay: 0.315,
    wheelName: "Inspect What You Expect",
  },
  {
    id: "marketing",
    d: "M 292.35 365.72 A 242 242 0 0 1 413.67 263.92 L 465.04 398.45 A 98 98 0 0 0 415.91 439.67 Z",
    fill: "#C8102E",
    delay: 0.36,
    wheelName: "Generate Demand",
  },
];
